/*
  Mije Seoul — wishlist (Saved) + notify-me behaviour.

  WISHLIST STORAGE — guest-first, localStorage-backed.
  ----------------------------------------------------
  Store shape: localStorage["mije.wishlist.v1"] = JSON array of product
  handles, newest first. All reads/writes go through MijeWishlist below —
  that object is the seam for the future customer-metafield sync:
  when a logged-in customer sync lands (later phase), replace load()/save()
  with a merge against a customer metafield (e.g. mije.wishlist, written via
  an app proxy or Storefront API customer mutation) and keep this API
  surface identical. Nothing else in the theme touches storage directly.

  NOTIFY-ME — see docs/notify-me.md for the storage model + limitation.
*/

(function () {
  'use strict';

  var KEY = 'mije.wishlist.v1';

  var MijeWishlist = {
    load: function () {
      try {
        var raw = JSON.parse(localStorage.getItem(KEY) || '[]');
        return Array.isArray(raw) ? raw : [];
      } catch (e) {
        return [];
      }
    },
    save: function (handles) {
      try {
        localStorage.setItem(KEY, JSON.stringify(handles));
      } catch (e) {
        /* storage full / private mode — wishlist degrades to per-page state */
      }
      render();
    },
    has: function (handle) {
      return this.load().indexOf(handle) !== -1;
    },
    toggle: function (handle) {
      var handles = this.load();
      var i = handles.indexOf(handle);
      if (i === -1) handles.unshift(handle);
      else handles.splice(i, 1);
      this.save(handles);
      return i === -1;
    },
    remove: function (handle) {
      this.save(
        this.load().filter(function (h) {
          return h !== handle;
        })
      );
    },
    count: function () {
      return this.load().length;
    },
  };
  window.MijeWishlist = MijeWishlist;

  /* the PDP's own hearts carry no data attributes — derive the handle */
  function pageProductHandle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function buttonHandle(btn) {
    return btn.getAttribute('data-handle') || pageProductHandle();
  }

  function isHeart(btn) {
    return btn.matches(
      '[data-wishlist-toggle], .mj-card__wish, .mj-pdp__wish, .mj-pdp__wish-float, .mj-pdp-bar__wish'
    );
  }

  function render() {
    var n = MijeWishlist.count();

    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n > 0 ? '(' + n + ')' : '';
    });

    document
      .querySelectorAll(
        '[data-wishlist-toggle], .mj-card__wish, .mj-pdp__wish, .mj-pdp__wish-float, .mj-pdp-bar__wish'
      )
      .forEach(function (btn) {
        var handle = buttonHandle(btn);
        if (!handle) return;
        var saved = MijeWishlist.has(handle);
        btn.classList.toggle('is-saved', saved);
        btn.textContent = saved ? '♥' : '♡';
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button');
    if (!btn || !isHeart(btn)) return;
    var handle = buttonHandle(btn);
    if (!handle) return;
    e.preventDefault();
    MijeWishlist.toggle(handle);
  });

  /* other tabs */
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) render();
  });

  document.addEventListener('DOMContentLoaded', render);
  render();

  /* ------------------------------------------------------------ saved page */

  var grid = document.querySelector('[data-saved-grid]');
  if (grid) {
    var emptyEl = document.querySelector('[data-saved-empty]');

    var renderSaved = function () {
      var handles = MijeWishlist.load();
      grid.innerHTML = '';
      if (emptyEl) emptyEl.hidden = handles.length > 0;
      if (!handles.length) return;

      handles.forEach(function (handle) {
        var cell = document.createElement('article');
        cell.className = 'mj-card';
        cell.setAttribute('data-saved-item', handle);
        grid.appendChild(cell);

        fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function (r) {
            if (!r.ok) throw new Error('gone');
            return r.json();
          })
          .then(function (p) {
            var imgUrl = p.featured_image
              ? p.featured_image + (p.featured_image.indexOf('?') === -1 ? '?width=600' : '&width=600')
              : null;
            var img = imgUrl ? '<img src="' + imgUrl + '" alt="" loading="lazy">' : '';
            var money = window.MijeMoney || defaultMoney;
            var v0 = p.variants && p.variants[0];
            var onSale = v0 && v0.compare_at_price && v0.compare_at_price > v0.price;
            var price = onSale
              ? '<s class="mj-price-was">' + money(v0.compare_at_price) + '</s> ' + money(p.price)
              : money(p.price);
            cell.innerHTML =
              '<div class="mj-card__media' + (p.available ? '' : ' is-soldout') + '">' +
              '<a href="' + p.url + '">' + img + '</a>' +
              '<button type="button" class="mj-card__wish mj-circle is-saved" data-wishlist-toggle data-handle="' + handle + '" aria-label="Remove from saved">♥</button>' +
              (onSale ? '<span class="mj-card__badge mj-card__badge--accent mj-card__badge--sale">Sale</span>' : '') +
              (p.available ? '' : '<span class="mj-card__badge">Sold out</span>') +
              '</div>' +
              '<div class="mj-card__info">' +
              '<div class="mj-card__row">' +
              '<h3 class="mj-card__title"><a href="' + p.url + '">' + escapeHtml(p.title) + '</a></h3>' +
              '<span class="mj-card__price">' + price + '</span>' +
              '</div>' +
              '<p class="mj-card__model">One size</p>' +
              '</div>';
          })
          .catch(function () {
            /* product deleted/unpublished — drop it from the store */
            MijeWishlist.remove(handle);
            cell.remove();
          });
      });
    };

    var defaultMoney = function (cents) {
      return new Intl.NumberFormat('en-SG', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'SGD',
      }).format(cents / 100);
    };

    var escapeHtml = function (s) {
      var d = document.createElement('div');
      d.textContent = s;
      return d.innerHTML;
    };

    renderSaved();
    /* re-render after a toggle (remove) — save() calls render(); hook storage-ish path */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-saved-item] [data-wishlist-toggle]');
      if (btn) setTimeout(renderSaved, 0);
    });
    window.addEventListener('storage', function (e) {
      if (e.key === KEY) renderSaved();
    });
  }

  /* -------------------------------------------------------------- notify-me */

  var modal = document.querySelector('[data-notify-modal]');
  if (modal) {
    var tagsInput = modal.querySelector('[data-notify-tags]');
    var contextEl = modal.querySelector('[data-notify-context]');

    var openModal = function () {
      var variantInput = document.querySelector('[data-variant-id]');
      var handle = pageProductHandle() || '';
      var variantId = variantInput ? variantInput.value : '';
      if (tagsInput) tagsInput.value = 'notify-restock,variant-' + variantId + ',product-' + handle;
      if (contextEl) contextEl.textContent = document.title.split('–')[0].trim();
      modal.hidden = false;
      var email = modal.querySelector('input[type="email"]');
      if (email) email.focus();
    };

    var closeModal = function () {
      modal.hidden = true;
    };

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-notify-close]') || e.target === modal) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    /* swap "Notify me" in for a disabled Add to bag (sold-out / pre-order OOS) */
    var applyNotifyState = function () {
      document.querySelectorAll('[data-add-to-bag]').forEach(function (addBtn) {
        var notifyBtn = addBtn.parentElement.querySelector('[data-notify-open]');
        if (!notifyBtn) {
          notifyBtn = document.createElement('button');
          notifyBtn.type = 'button';
          notifyBtn.className = addBtn.className + ' mj-btn--outline';
          notifyBtn.setAttribute('data-notify-open', '');
          notifyBtn.textContent = 'Notify me';
          notifyBtn.addEventListener('click', openModal);
          addBtn.parentElement.insertBefore(notifyBtn, addBtn.nextSibling);
        }
        var oos = addBtn.disabled;
        notifyBtn.hidden = !oos;
        addBtn.hidden = oos;
      });
    };

    applyNotifyState();
    /* variant switching (mije-pdp.js) toggles the disabled attribute */
    document.querySelectorAll('[data-add-to-bag]').forEach(function (btn) {
      new MutationObserver(applyNotifyState).observe(btn, { attributes: true, attributeFilter: ['disabled'] });
    });

    /* Shopify redirects back with ?customer_posted=true after a successful post.
       The pending flag (written by mije-overlays.js at submit time) tells the
       newsletter and notify posts apart — without it, behave as before. */
    var pendingKind = null;
    try {
      pendingKind = sessionStorage.getItem('mije.posted.pending');
    } catch (e) { /* private mode */ }
    if (
      new URLSearchParams(window.location.search).get('customer_posted') === 'true' &&
      pendingKind !== 'newsletter'
    ) {
      if (pendingKind === 'notify') {
        try {
          sessionStorage.removeItem('mije.posted.pending');
        } catch (e) { /* private mode */ }
      }
      modal.hidden = false;
      var formEl = modal.querySelector('form');
      var doneEl = modal.querySelector('[data-notify-done]');
      if (formEl) formEl.hidden = true;
      if (doneEl) doneEl.hidden = false;
    }
  }
})();
